// 此action文件为定义微应用之间全局状态
// 引入qiankun的应用间通信方法initGlobalState
import { initGlobalState } from "qiankun";
import store from "../store";
import Vue from "vue";
import { routerGo } from "@/util/utils.js"; // 引入跨应用路由跳转

const initialState = {
  // 这里可以写初始化数据
};
const actions = initGlobalState(initialState); //初始化state

// 监听actions全局公共状态数据的变化
actions.onGlobalStateChange((state) => {
  // 打开新页签
  console.log(state);

  if (state.gotoObj) goto(state.gotoObj);
});

function goto(item) {
  routerGo(item.url, item.title);
  const tagObj = {
    label: item.title,
    value: item.url,
    ...item,
  };
  store.commit("ADD_TAG", tagObj);
  new Vue().$emit("openTag", tagObj);
}
export default actions;
